import { Injectable } from '@angular/core';
import { Config } from './config';

@Injectable()
export class ConfigService {
  config: Config;
}
